import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _invert from "lodash/invert";

var _incomeBeneficiaryTyp, _incomeSourceTypesNam;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var INCOME_BENEFICIARY_TYPE = {
  borrower: 'borrower',
  husbandWife: 'husbandWife',
  fatherMother: 'fatherMother',
  sonDaughter: 'sonDaughter',
  brotherSister: 'brotherSister',
  domesticPartner: 'domesticPartner'
};
export var incomeBeneficiaryTypesName = (_incomeBeneficiaryTyp = {}, _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.borrower, 'Заемоискател'), _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.husbandWife, 'Съпруг/а'), _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.fatherMother, 'Майка/Баща'), _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.sonDaughter, 'Син/Дъщеря'), _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.brotherSister, 'Брат/Сестра'), _defineProperty(_incomeBeneficiaryTyp, INCOME_BENEFICIARY_TYPE.domesticPartner, 'Семеен партньор'), _incomeBeneficiaryTyp);
export var incomeBeneficiaryTypesNameSelect = Object.entries(_invert(incomeBeneficiaryTypesName)).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      value = _ref2[1];

  return {
    label: label,
    value: value
  };
});
export var INCOME_SOURCE_TYPE = {
  salary: 'salary',
  pension: 'pension',
  childBenefits: 'childBenefits',
  other: 'other'
};
export var incomeSourceTypesName = (_incomeSourceTypesNam = {}, _defineProperty(_incomeSourceTypesNam, INCOME_SOURCE_TYPE.salary, 'Заплата'), _defineProperty(_incomeSourceTypesNam, INCOME_SOURCE_TYPE.pension, 'Пенсия'), _defineProperty(_incomeSourceTypesNam, INCOME_SOURCE_TYPE.childBenefits, 'Детски'), _defineProperty(_incomeSourceTypesNam, INCOME_SOURCE_TYPE.other, 'Други'), _incomeSourceTypesNam);
export var incomeSourceTypesNameSelect = Object.entries(_invert(incomeSourceTypesName)).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      label = _ref4[0],
      value = _ref4[1];

  return {
    label: label,
    value: value
  };
});